import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Login from './pages/Login'
import AdminLogin from './pages/AdminLogin'
import Register from './pages/Register'
import ProdutorDashboard from './pages/produtor/Dashboard'
import ProdutorEditais from './pages/produtor/Editais'
import ProdutorPerfil from './pages/produtor/Perfil'
import AgroeconomiaDashboard from './pages/agroeconomia/Dashboard'
import EducacaoDashboard from './pages/educacao/Dashboard'
import Footer from './components/Footer'
import AdminLayout from './pages/AdminLayout'
import Sidebar from './pages/Sidebar'
import Formprodutor from './pages/agroeconomia/Formprodutor'
import Formalimento from './pages/agroeconomia/Formalimento'

import Formedital from './pages/agroeconomia/Formedital'
import EditaisProdutos from './pages/agroeconomia/EditaisProdutosPage'
import FormGrupoAssociacao from './pages/agroeconomia/FormGrupoAssociacao'
import Relatorios from './pages/agroeconomia/Relatorios'
import AlterarSenhaProdutor from './pages/agroeconomia/AlterarSenhaProdutor'
import FormUsuarioAdmin from './pages/agroeconomia/FormUsuarioAdmin'

const PrivateRoute = ({ children, allowedRoles = [], redirectTo = '/login' }) => {
  const { isAuthenticated, user, loading } = useAuth()

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Carregando...</div>
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.tipo)) {
    return <Navigate to="/" replace />
  }

  return children
}



const App = () => {

  const { isAuthenticated, user, loading } = useAuth();
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/register" element={<Register />} />
        
        <Route
          path="/produtor"
          element={
            <PrivateRoute allowedRoles={['produtor']}>
              <ProdutorDashboard />
              {/* <Footer /> */}
            </PrivateRoute>
          }
        />
        <Route
          path="/produtor/editais"
          element={
            <PrivateRoute allowedRoles={['produtor']}>
              <ProdutorEditais />
              {/* <Footer /> */}
            </PrivateRoute>
          }
        />
        <Route
          path="/produtor/perfil"
          element={
            <PrivateRoute allowedRoles={['produtor']}>
              <ProdutorPerfil />
              {/* <Footer /> */}
            </PrivateRoute>
          }
        />
        
        <Route
          path="/agroeconomia"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <AgroeconomiaDashboard />
              
            </PrivateRoute>
          }
        />

        <Route
          path="/formprodutor"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <Formprodutor />
              
            </PrivateRoute>
          }
        />

        <Route
          path="/formedital"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <Formedital />
              
            </PrivateRoute>
          }
        />

        <Route
          path="/formalimento"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <Formalimento />
              
            </PrivateRoute>
          }
        />

        <Route
          path="/formgrupoassociacao"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <FormGrupoAssociacao />

            </PrivateRoute>
          }
        />

        <Route
          path="/editaisprodutos"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <EditaisProdutos />
            </PrivateRoute>
          }
        />

        <Route
          path="/relatorios"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <Relatorios />
            </PrivateRoute>
          }
        />

        <Route
          path="/alterarsenhaprodutor"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <AlterarSenhaProdutor />
            </PrivateRoute>
          }
        />

        <Route
          path="/formusuarioadmin"
          element={
            <PrivateRoute allowedRoles={['agroeconomia']} redirectTo="/admin/login">
              <Sidebar user={user} />
              <FormUsuarioAdmin />
            </PrivateRoute>
          }
        />

        <Route
          path="/educacao"
          element={
            <PrivateRoute allowedRoles={['educacao']} redirectTo="/admin/login">
              <EducacaoDashboard />
            </PrivateRoute>
          }
        />
        
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
      
    </Router>
  )
}

export default App

